export const SCOPE = 'https://graph.microsoft.com/user.read';
//# sourceMappingURL=msal.service.config.js.map